export enum SubscriptionIdType {
  NEWS_ID = 'newsid',
  EVENT_ID = 'eventid',
  ACTIVITY_ID = 'activityid'
}
